'use client'

import { Suspense } from 'react'
import dynamic from 'next/dynamic'

import { useLocation } from '@marketplace-web/shared/browser'

import { InboxNew } from '@marketplace-web/messaging/conversation-messaging-new-feature'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

import WebsocketChannels from '../../components/WebsocketChannels'

type Props = {
  websocketHostUrl: string
}

const Inbox = dynamic(() => import('../Inbox').then(module => module.default), {
  ssr: false,
})

const InboxWithLocation = ({ websocketHostUrl }: Props) => {
  const { href } = useLocation()

  const isWebMessagingSvcFSEnabled = useFeatureSwitch('web_messaging_svc')

  return isWebMessagingSvcFSEnabled ? (
    <InboxNew />
  ) : (
    <Suspense fallback={null}>
      <Inbox
        websocketHostUrl={websocketHostUrl}
        location={href}
        renderWebsocketChannels={({ websocketHostUrl: hostUrl }) => (
          <WebsocketChannels websocketHostUrl={hostUrl} />
        )}
      />
    </Suspense>
  )
}

export default InboxWithLocation
